var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.2175 5.412C11.4453 5.6398 11.4439 6.0106 11.2161 6.23841C10.9882 6.46622 10.6174 6.46767 10.3896 6.23986L5.99859 1.84881L1.60753 6.23986C1.37973 6.46767 1.00893 6.46622 0.781121 6.23841C0.553315 6.0106 0.551861 5.6398 0.779666 5.412L5.58611 0.605557C5.81391 0.377751 6.18326 0.377751 6.41106 0.605558L11.2175 5.412Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferArrowUp);
export default __webpack_public_path__ + "static/media/OfferArrowUp.35c96e7a36aa28a60b7f3450caec1363.svg";
export { ForwardRef as ReactComponent };